import { render, staticRenderFns } from "./AuthContent.vue?vue&type=template&id=1f566353&scoped=true&"
var script = {}
import style0 from "./AuthContent.vue?vue&type=style&index=0&id=1f566353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f566353",
  null
  
)

export default component.exports